<template>

  <!--
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
         <b>Copyright</b> &copy; {{ year }}&nbsp;Digital Communications Consulting. LLC. <br>All Rights Reserved.
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <router-link href="#"  target="_blank">
            <b>Version</b> {{configFooter}}
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
  -->

  <Footer></Footer>

</template>
<script>
import initService from "../../common/api-services/init-service";
import Footer from './Footer.vue'

export default {
  components: {
    Footer
  },
  data() {
    return {
      year: new Date().getFullYear(),
      configFooter: ""
    };
  },
  mounted() {
    this.getFooterConfig()
  },
  computed: {
    uxVersion() {
      return initService.getUxVersion();
    },
    apiVersion() {
      return initService.getApiVersion();
    },
  },
  methods: {
    getFooterConfig() {
      this.configFooter = initService.getUxVersion()
    }
  }
};
</script>
